import OrderLevelIssues from '../components/widgets/OrderLevelIssues/OrderLevelIssues';
import {
  OrderNotDelivered,
  OrderSpilled,
  DelightCreditsBlinkit,
  DefaultView,
} from '../components/widgets/ReportIssue/Issues';

export const issues1 = {
  201: DefaultView,
  202: DefaultView,
  203: DefaultView,
  204: DefaultView,
  205: DefaultView,
  206: DefaultView,
  207: DefaultView,
  208: DefaultView,
  104: OrderNotDelivered,
  106: DelightCreditsBlinkit,
  109: DelightCreditsBlinkit,
  301: DefaultView,
  302: DefaultView,
  303: DefaultView,
  305: DefaultView,
  307: DefaultView,
  308: DefaultView,
  309: DefaultView,
  310: DefaultView,
  311: DefaultView,
  312: DefaultView,
};

export const issuesSlug = {
  COMPLAINT_DAMAGED_ITEM: OrderSpilled,
  COMPLAINT_FAKE_OR_DUPLICATE_ITEM: OrderSpilled,
  COMPLAINT_QUALITY_ISSUE: OrderSpilled,
  COMPLAINT_FAULTY_ITEM: OrderSpilled,
  COMPLAINT_ORDER_NOT_DELIVERED: OrderLevelIssues,
  COMPLAINT_SURGE_CHARGE: OrderLevelIssues,
  COMPLAINT_DELIVERY_CHARGE: OrderLevelIssues,
  COMPLAINT_HANDLING_CHARGE: OrderLevelIssues,
  COMPLAINT_GIFT_PACKING_CHARGE: OrderLevelIssues,
  COMPLAINT_BISTRO_ORDER_NOT_DELIVERED: OrderLevelIssues,
  COMPLAINT_BISTRO_DELIGHT_RESOLUTION: OrderLevelIssues,
  COMPLAINT_DELIGHT_RESOLUTION: OrderLevelIssues,
  COMPLAINT_EMERGENCY_ISSUE: OrderLevelIssues,
  COMPLAINT_PRICE_MISMATCH: OrderSpilled,
  COMPLAINT_CONDIMENT_QUALITY_ISSUE: OrderLevelIssues,
  COMPLAINT_CONDIMENT_SPILLAGE_ISSUE: OrderLevelIssues,
  COMPLAINT_CONDIMENT_MISSING_ITEM: OrderLevelIssues,
  COMPLAINT_CONDIMENT_WRONG_ITEM: OrderLevelIssues,
  COMPLAINT_REFUND_CANCELLED_ORDER: OrderLevelIssues,
  COMPLAINT_CANCELLATION_FEE: OrderLevelIssues,
  COMPLAINT_WRONG_ORDER: OrderLevelIssues,
  COMPLAINT_ORDER_PACKAGING_ISSUE: OrderLevelIssues,
};

export const merchantDesignationMappingWithLiterals = {
  'Assistant Store Manager': 'asm',
  'Store Manager': 'sm',
  'Team Leader': 'tl',
  'Depot Manager': 'DEPOT_MANAGER',
};
